import "font-awesome/css/font-awesome.min.css";
import SocialNetwork from "./SocialNetwork";
import AboutMe from "./AboutMe";

const Profile = () => {
  return (
    <div id="profile" className="profile__container">
      <div className="profile__picture">
        <img
          className="profile__avatar"
          src={require("../assets/images/riawinter.jpeg")}
          alt="foto-me"
        />
      </div>

      <div className="profile__info">
        <div
          data-aos="fade-left"
          data-aos-delay="50"
          data-aos-duration="1000"
          className="profile__fullname"
        >
          Ria Ratnasari
        </div>

        <div
          data-aos="fade-left"
          data-aos-delay="50"
          data-aos-duration="1000"
          className="profile__job-title"
        >
          Full-Stack Developer with 8+ years experiences
        </div>
        <AboutMe />
        <SocialNetwork />
      </div>
    </div>
  );
};

export default Profile;
